import { useState, useEffect } from 'react';
import { useUserStore } from '@/store/userStore';
import { getUserProfile } from '@/services/userProfileService';

export interface UserProfile {
  id: string;
  first_name: string | null;
  last_name: string | null;
  phone: string | null;
  profile_photo_url: string | null;
  gym_id: string | null;
}

export const useUserProfile = () => {
  const { user } = useUserStore();
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!user?.id) {
        setIsLoading(false);
        return;
      }

      try {
        const data = await getUserProfile(user.id);
        setProfile(data);
      } catch (error) {
        console.error('Error fetching user profile:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfile();
  }, [user?.id]);

  return { profile, isLoading };
};
